var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399CDB",
    d: "M0 23.979C0 37.22 10.745 47.957 24 47.957S48 37.22 48 23.979C48 10.735 37.255 0 24 0S0 10.735 0 23.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.9 25.25L15.5 20 11 24.375l5.4 5.249L20.9 34 38 17.374 33.5 13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickCircle);
export default __webpack_public_path__ + "static/media/icon-tick-circle.17a4d8133f0610cdbc719cc991af2582.svg";
export { ForwardRef as ReactComponent };